var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { zodResolver } from '@hookform/resolvers/zod';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid2 as Grid, Typography, } from '@mui/material';
import React, { useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import DocumentSection from '../../../components/Documento/DocumentSection';
import EstadoSelect from '../../../components/Form/EstadoSelect';
import MaskedTextFieldControl from '../../../components/Form/MaskedTextFieldControl';
import { PHONE_MASK } from '../../../util/masks';
import MunicipioSelect from '../../../components/Form/MunicipioSelect';
import TextFieldControl from '../../../components/Form/TextFieldControl';
import { useDocumentValidation } from '../../../hooks/useDocumentValidation';
import { useProcessContext } from '../context/ProcessContext';
import { EntidadeAnalise } from '../../../enums/analise.enum';
import { getDisabledFlags } from '../../../util/analise.utils';
import { AnaliseGrupoStatusComponent } from '../../../components/Analise/AnaliseGrupoStatusComponent';
import { isValidCpf } from '../../../util/is-valid-cpf.util';
var socioSchema = z.object({
    nome: z
        .string()
        .min(1, 'Nome é obrigatório')
        .max(100, 'Tamanho máximo excedido.'),
    cpf: z
        .string()
        .min(1, 'CPF inválido')
        .regex(/^\d{3}\.\d{3}\.\d{3}-\d{2}$/)
        .refine(function (cpf) { return isValidCpf(cpf); }, {
        message: 'CPF informado é inválido',
    }),
    cep: z
        .string()
        .min(9, 'CEP inválido')
        .regex(/^\d{5}-\d{3}$/),
    logradouro: z
        .string()
        .min(1, 'Logradouro é obrigatório')
        .max(100, 'Tamanho máximo excedido.'),
    numero: z
        .string()
        .min(1, 'Número é obrigatório')
        .max(10, 'Tamanho máximo excedido.'),
    complemento: z.string().max(100, 'Tamanho máximo excedido.').optional(),
    bairro: z
        .string()
        .min(1, 'Bairro é obrigatório')
        .max(100, 'Tamanho máximo excedido.'),
    cidade: z
        .number({ message: 'Selecione o município' })
        .min(1, 'Cidade é obrigatória'),
    uf: z.string().min(1, 'UF é obrigatória'),
    email: z
        .string()
        .email('E-mail inválido')
        .max(100, 'Tamanho máximo excedido.'),
    telefone: z
        .string()
        .min(14, 'Telefone inválido')
        .max(15, 'Tamanho máximo excedido.')
        .regex(/^\(\d{2}\) \d{4,5}-\d{4}$/),
});
var DEFAULT_VALUES = {
    nome: '',
    cpf: '',
    cep: '',
    logradouro: '',
    numero: '',
    complemento: '',
    bairro: '',
    cidade: '',
    uf: '',
    email: '',
    telefone: '',
};
export var SocioModalForm = function (_a) {
    var _b, _c, _d;
    var open = _a.open, socio = _a.socio, modo = _a.modo, onClose = _a.onClose, onSave = _a.onSave;
    var _e = useProcessContext(), servico = _e.servico, analise = _e.analise;
    var _f = useForm({
        resolver: zodResolver(socioSchema),
        defaultValues: socio || DEFAULT_VALUES,
    }), control = _f.control, watch = _f.watch, handleSubmit = _f.handleSubmit;
    var disabled = useMemo(function () { return modo === 'visualizar'; }, [modo]);
    var _g = getDisabledFlags(EntidadeAnalise.SOCIO, socio === null || socio === void 0 ? void 0 : socio.id, analise === null || analise === void 0 ? void 0 : analise.gruposCampos, disabled), disabledDadosGerais = _g.disabledDadosGerais, disabledEndereco = _g.disabledEndereco, disabledContato = _g.disabledContato;
    var secoesDocumentos = (_c = (_b = servico === null || servico === void 0 ? void 0 : servico.secoesDocumentos) === null || _b === void 0 ? void 0 : _b.filter(function (x) { return x.categoria === 'SOCIO'; })) !== null && _c !== void 0 ? _c : [];
    var _h = useDocumentValidation((_d = socio === null || socio === void 0 ? void 0 : socio.documentos) !== null && _d !== void 0 ? _d : []), documentosAnexados = _h.documentosAnexados, errors = _h.errors, validateAllSections = _h.validateAllSections, handleUpdateDocumento = _h.handleUpdateDocumento;
    var onSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var allValid, socioData;
        return __generator(this, function (_a) {
            try {
                allValid = validateAllSections(secoesDocumentos);
                if (!allValid) {
                    return [2 /*return*/];
                }
                socioData = __assign(__assign({}, data), { documentos: documentosAnexados });
                if (onSave) {
                    onSave(socioData);
                }
                else {
                    onClose();
                }
            }
            catch (error) {
                console.error('Erro ao adicionar sócio:', error);
            }
            return [2 /*return*/];
        });
    }); };
    return (_jsxs(Dialog, { open: open, onClose: onClose, maxWidth: "lg", children: [_jsx(DialogTitle, { children: modo === 'adicionar'
                    ? 'Adicionar Sócio'
                    : modo === 'editar'
                        ? 'Editar Sócio'
                        : 'Visualizar Sócio' }), _jsx(DialogContent, { children: _jsxs(Box, { component: "form", onSubmit: handleSubmit(onSubmit), noValidate: true, children: [_jsx(Typography, { variant: "h6", children: "Informa\u00E7\u00F5es B\u00E1sicas" }), _jsx(AnaliseGrupoStatusComponent, { analise: analise, entidade: "SOCIO", grupo: "DADOS_GERAIS", entidadeAssociadaId: socio === null || socio === void 0 ? void 0 : socio.id, children: _jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { size: { xs: 12, md: 6 }, children: _jsx(TextFieldControl, { name: "nome", label: "Nome", control: control, required: true, disabled: disabledDadosGerais, maxLength: 100 }) }), _jsx(Grid, { size: { xs: 12, md: 6 }, children: _jsx(MaskedTextFieldControl, { name: "cpf", label: "CPF", control: control, mask: "000.000.000-00", required: true, disabled: disabledDadosGerais }) })] }) }), _jsx(Typography, { variant: "h6", sx: { mt: 3 }, children: "Dados de Endere\u00E7o" }), _jsx(AnaliseGrupoStatusComponent, { analise: analise, entidade: "SOCIO", grupo: "ENDERECO", entidadeAssociadaId: socio === null || socio === void 0 ? void 0 : socio.id, children: _jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { size: { xs: 12, md: 6 }, children: _jsx(MaskedTextFieldControl, { name: "cep", label: "CEP", control: control, mask: "00000-000", required: true, disabled: disabledEndereco }) }), _jsx(Grid, { size: { xs: 12, md: 6 }, children: _jsx("br", {}) }), _jsx(Grid, { size: { xs: 12, md: 6 }, children: _jsx(TextFieldControl, { name: "logradouro", label: "Logradouro", control: control, required: true, disabled: disabledEndereco, maxLength: 100 }) }), ' ', _jsx(Grid, { size: { xs: 12, md: 6 }, children: _jsx(TextFieldControl, { name: "numero", label: "N\u00FAmero", control: control, required: true, disabled: disabledEndereco, maxLength: 10 }) }), _jsx(Grid, { size: { xs: 12, md: 6 }, children: _jsx(TextFieldControl, { name: "complemento", label: "Complemento", control: control, disabled: disabledEndereco, maxLength: 100 }) }), _jsx(Grid, { size: { xs: 12, md: 6 }, children: _jsx(TextFieldControl, { name: "bairro", label: "Bairro", control: control, required: true, disabled: disabledEndereco, maxLength: 100 }) }), _jsx(Grid, { size: { xs: 12, md: 6 }, children: _jsx(EstadoSelect, { name: "uf", control: control, required: true, disabled: disabledEndereco }) }), _jsx(Grid, { size: { xs: 12, md: 6 }, children: _jsx(MunicipioSelect, { name: "cidade", control: control, disabled: disabledEndereco, estadoSigla: watch('uf'), required: true }) })] }) }), _jsx(Typography, { variant: "h6", sx: { mt: 3 }, children: "Dados de Contato" }), _jsx(AnaliseGrupoStatusComponent, { analise: analise, entidade: "SOCIO", grupo: "CONTATO", entidadeAssociadaId: socio === null || socio === void 0 ? void 0 : socio.id, children: _jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { size: { xs: 12, md: 6 }, children: _jsx(TextFieldControl, { name: "email", label: "E-mail", control: control, disabled: disabledContato, required: true, maxLength: 100 }) }), _jsx(Grid, { size: { xs: 12, md: 6 }, children: _jsx(MaskedTextFieldControl, { name: "telefone", label: "Telefone", control: control, disabled: disabledContato, mask: PHONE_MASK, required: true }) })] }) }), _jsx(Typography, { variant: "h6", sx: { mt: 3 }, children: "Documentos do S\u00F3cio" }), _jsx(Typography, { variant: "body2", color: "textSecondary", sx: { mb: 2 }, children: "Orientamos que o arquivo deve ser enviado no formato PDF, e o seu tamanho m\u00E1ximo n\u00E3o pode ultrapassar 5mb. Informe a data de validade de cada documento, caso o mesmo possua." }), secoesDocumentos.map(function (secao) { return (_jsx(DocumentSection, { secao: secao, disabled: disabled, analise: analise, documentosAnexados: documentosAnexados, onUpdateDocumento: handleUpdateDocumento, errors: errors[secao.id] }, secao.id)); })] }) }), _jsxs(DialogActions, { children: [_jsx(Button, { onClick: onClose, children: "Cancelar" }), !disabled && (_jsx(Button, { variant: "contained", color: "primary", type: "submit", onClick: handleSubmit(onSubmit), children: "Salvar" }))] })] }));
};
